export class Faculty {
  codigo: String;
  nombre: String;
  nombrejefe: String;
}
